import { Box, Divider, Typography } from "@mui/material";
import AdminTypeOption from "../../components/filterOption/AdminTypeOption";

/**
 * Demo component for AdminTypeOption
 * Shows different admin types and categories
 */
const AdminTypeOptionDemo = () => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {/* User admin types */}
      <Box>
        <Typography variant="subtitle2" gutterBottom>
          User Admin Types:
        </Typography>
        <Box display="flex" flexDirection="row" gap={3} flexWrap="wrap">
          <AdminTypeOption adminType="Admin" category="user" />
          <AdminTypeOption adminType="Editor" category="user" />
          <AdminTypeOption adminType="Viewer" category="user" />
        </Box>
      </Box>

      <Divider />

      {/* System admin types */}
      <Box>
        <Typography variant="subtitle2" gutterBottom>
          System Admin Types:
        </Typography>
        <Box display="flex" flexDirection="row" gap={3} flexWrap="wrap">
          <AdminTypeOption adminType="System Admin" category="system" />
          <AdminTypeOption adminType="System Operator" category="system" />
        </Box>
      </Box>
    </Box>
  );
};

export default AdminTypeOptionDemo;
